import React, { useState } from 'react';
import { disputesV2 } from '../services/api';
import toast from 'react-hot-toast';

const REASON_SVGS = {
  not_delivered: <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>,
  wrong_item:    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>,
  quality_issue: <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  payment_issue: <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="3"/><line x1="2" y1="10" x2="22" y2="10"/></svg>,
  other:         <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
};
const REASONS = [
  { v: 'not_delivered',  l: 'Not delivered' },
  { v: 'wrong_item',     l: 'Wrong item/service' },
  { v: 'quality_issue',  l: 'Quality issue' },
  { v: 'payment_issue',  l: 'Payment issue' },
  { v: 'other',          l: 'Other' },
];

export default function RaiseDisputeModal({ C, targetType, targetId, onClose, onSuccess }) {
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!reason) { toast.error('Pick a reason'); return; }
    if (description.trim().length < 10) {
      toast.error('Description must be at least 10 characters');
      return;
    }
    setSubmitting(true);
    try {
      const res = await disputesV2.raise(targetType, targetId, {
        reason,
        description: description.trim(),
        evidence_urls: [],
      });
      toast.success('Dispute raised. Admin will review.');
      if (onSuccess) onSuccess(res.id);
      else onClose();
    } catch(e) {
      toast.error(e.message || 'Could not raise dispute');
      setSubmitting(false);
    }
  };

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.85)',zIndex:10001,display:'flex',alignItems:'flex-end',justifyContent:'center'}}>
      <div onClick={e=>e.stopPropagation()} style={{background:C.bg,borderRadius:'24px 24px 0 0',width:'100%',maxWidth:430,maxHeight:'92vh',overflowY:'auto',padding:16}}>
        <div style={{display:'flex',justifyContent:'space-between',marginBottom:14}}>
          <div>
            <div style={{fontSize:16,fontWeight:800,color:C.text}}>Raise a Dispute</div>
            <div style={{fontSize:11,color:C.muted,marginTop:2}}>An admin will review and resolve.</div>
          </div>
          <button onClick={onClose} style={{background:C.input,border:`1px solid ${C.border}`,borderRadius:'50%',width:32,height:32,cursor:'pointer',color:C.muted,display:'flex',alignItems:'center',justifyContent:'center'}}>
            <svg viewBox="0 0 24 24" width="14" height="14" stroke={C.muted} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div style={{padding:'10px 12px',background:'#1a3cc812',border:'1px solid #1a3cc830',borderRadius:8,marginBottom:14,fontSize:11,color:'#1a3cc8',lineHeight:1.5,display:'flex',gap:8,alignItems:'flex-start'}}>
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="#1a3cc8" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,marginTop:1}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span>Only raise a dispute after attempting to resolve directly with the other party. False disputes may affect your trust score.</span>
        </div>

        <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:0.8,marginBottom:8,color:C.muted}}>What's the issue?</div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:6,marginBottom:14}}>
          {REASONS.map(r => (
            <button key={r.v} type="button" onClick={()=>setReason(r.v)} style={{
              background: reason===r.v ? `${C.primary}18` : C.input,
              border: `2px solid ${reason===r.v ? C.primary : C.border}`,
              borderRadius:10, padding:'10px 8px', cursor:'pointer',
              display:'flex', alignItems:'center', gap:8, color:C.text,
              fontSize:12, fontWeight:reason===r.v?700:500,
            }}>
              <span style={{color:reason===r.v?'#1a3cc8':C.muted}}>{REASON_SVGS[r.v]}</span>
              <span>{r.l}</span>
            </button>
          ))}
        </div>

        <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:0.8,marginBottom:8,color:C.muted}}>Describe what happened</div>
        <textarea
          placeholder="Be specific — describe the issue clearly so an admin can investigate. Include dates, amounts, and what was promised vs what happened."
          value={description}
          onChange={e=>setDescription(e.target.value)}
          style={{
            width:'100%', minHeight:120, padding:'10px 12px', background:C.input,
            border:`1px solid ${C.border}`, borderRadius:10, color:C.text, fontSize:13,
            outline:'none', resize:'vertical', marginBottom:14, boxSizing:'border-box',
          }}
        />

        <button onClick={submit} disabled={submitting} style={{
          width:'100%', background:'#e53935', border:'none', borderRadius:12,
          padding:'14px', color:'#fff', fontSize:14, fontWeight:800,
          cursor: submitting ? 'wait' : 'pointer',
        }}>
          {submitting ? 'Submitting...' : 'Submit Dispute'}
        </button>
      </div>
    </div>
  );
}
